var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav-menu',{attrs:{"options":_vm.options},model:{value:(_vm.menuSelected),callback:function ($$v) {_vm.menuSelected=$$v},expression:"menuSelected"}})}
var staticRenderFns = []

export { render, staticRenderFns }